import { render, staticRenderFns } from "./ServiceBillDetails.vue?vue&type=template&id=68c88be4&scoped=true"
import script from "./ServiceBillDetails.vue?vue&type=script&lang=ts"
export * from "./ServiceBillDetails.vue?vue&type=script&lang=ts"
import style0 from "./ServiceBillDetails.vue?vue&type=style&index=0&id=68c88be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c88be4",
  null
  
)

export default component.exports